module.exports = __webpack_public_path__ + "img/united-rugby-championship-logo-default.5ba4f2ef.png";